<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  details: DetailsCarItemDetails
}

const props = defineProps<Props>()
const { missingParts } = usePrepareDetailsCarData(
  computed(() => props.details),
)
</script>

<template>
  <div v-if="missingParts.display" class="col-span-12 lg:col-span-6">
    <SectionsDetailsElementsSection>
      <template #heading>
        {{ missingParts.title }}
      </template>

      <template #content>
        <SectionsDetailsElementsList
          v-if="missingParts.list.length"
          :elements="missingParts.list"
          :element-class="missingParts.renderInTwoColumns ? 'w-1/2' : ''"
          :class="{
            'flex flex-wrap': missingParts.renderInTwoColumns,
          }"
        />

        <SectionsDetailsElementsFreeText
          v-if="missingParts.freeText.length"
          :has-border="missingParts.list.length > 0"
          :free-text="missingParts.freeText"
        />
      </template>
    </SectionsDetailsElementsSection>
  </div>
</template>
